import { Component, computed, model } from '@angular/core';
import type { PageInfo } from '../../common/types';
import { addCheckboxColumn, addRowNumberColumn } from '../utils/column.utils';
import {
  addCheckboxField,
  addRowNumber,
  addUniqueId,
} from '../utils/row-data.utils';
import { GridViewBase } from '../view/grid-view-base.component';

@Component({
  template: ``,
  standalone: true,
})
export abstract class BaseDataGrid extends GridViewBase {
  public pageInfo = model<PageInfo | null>(null);

  protected readonly processedColumns = computed(() => {
    let columns = [...(this._rawColumns() ?? [])];
    const options = this._rawOptions();

    if (!options || options.view !== 'table') return columns;

    // rowNumber 컬럼 추가
    if (options.rowNumber) {
      columns = addRowNumberColumn(columns);
    }

    // checkbox 컬럼 추가
    if (options.checkbox) {
      columns = addCheckboxColumn(columns);
    }

    return columns;
  });

  protected readonly processedRowData = computed(() => {
    let rowData = this._rawRowData();
    const options = this._rawOptions();

    if (!options || !rowData) return rowData;

    // 공통: unique ID 추가
    rowData = addUniqueId(rowData);

    // 테이블 모드일 경우
    if (options.view === 'table') {
      if (options.rowNumber) {
        rowData = addRowNumber(rowData, this.pageInfo());
      }

      if (options.checkbox) {
        rowData = addCheckboxField(rowData);
      }
    }

    return rowData;
  });

  /**
   * Update store with processed data
   * Child classes should call this when they need to sync to store
   */
  protected updateStore(): void {
    const options = this._rawOptions();
    if (!options) return;

    this.store.rowData.set(this.processedRowData() ?? []);
    this.store.columns.set(this.processedColumns());
    this.store.options.set(options);
  }
}
